<template>
  <div>
    <div class="mb-5 text-blue-800 font-bold">
      ※全て発注金額
    </div>
    <div class="flex items-start main">
      <table class="mb-5">
        <tr v-for="(c, i) in column1" :key="i" class="hover-color text-left">
          <th class="th-name">
            <div v-if="c.name" :class="c.class" class="p-1 ml-1 mb-1">
              {{ c.name }}
            </div>
          </th>
          <td>
            <div v-if="price1[i]">
              <NumericTextInput
                name="price"
                class="text-right rounded border-gray-300 w-28 ml-5 bg-teal-50"
                v-model="price1[i].price"
                @change="changeData(price1[i])"
              />
            </div>
          </td>
        </tr>
      </table>

      <!-- エリア範囲 -->
      <table class="ml-10 border-orange rounded">
        <tr class="orange">
          <th  colspan="2">
            <div class="p-3">
              超都心
            </div>
          </th>
        </tr>
        <tr class="hover-color2 text-right">
          <th class="text-left bg-white">
            <div class="ml-5 mr-5 whitespace-pre">
              {{ nameEria1 }}
            </div>
          </th>
        </tr>
      </table>
      
      <!-- エリア範囲 -->
      <table class="ml-10 border-orange rounded">
        <tr class="orange">
          <th  colspan="2">
            <div class="p-3">
              都心
            </div>
          </th>
        </tr>
        <tr class="hover-color2 text-right">
          <th class="text-left bg-white">
            <div class="ml-5 mr-5 whitespace-pre">
              {{ nameEria2 }}
            </div>
          </th>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>

import NumericTextInput from '@components/NumericTextInput.vue'
import * as eriaManager from '@managers/eriaManager'
import * as utils from '@libs/utils'

/**
 * 増圧ポンプ
 */
const CATEGORY = '20'

export default {
  components: {
    NumericTextInput,
  },

  props: {
    code: {
      type: String
    }
  },

  data() {
    return {
      // カラム
      column1: [
        { name: '単価' },
        { name: '駐車場代：超都心' },
        { name: '駐車場代：都心' },
        { name: '駐車場代：その他' },
      ],
      // 単価
      price1: [],
      // エリア名
      nameEria1: '',
      nameEria2: ''
    }
  },

  created() {
    this.dataByCategory()
  },
  
  methods: {
    /**
     * 単価データを取得
     */
    async dataByCategory() {

      // カテゴリーに関するデータ取得
      const list = utils.clone(this.$store.getters.estimateItemPriceList)
      const dbc = list.filter((l) => {
        return l.parentCode == CATEGORY
      })

      this.price1 = this.setSort(dbc)

      // エリア範囲
      this.nameEria1 = ''
      this.nameEria2 = ''
      let nameEria = await eriaManager.getBooster(this, '東京都')
      let e1 = []
      let e2 = []
      nameEria.forEach(e => {
        if (e.eria == '超都心') {
          e1.push(e)
        } else {
          e2.push(e)
        }
      })

      this.nameEria1 = this.getEria(e1)
      this.nameEria2 = this.getEria(e2)
    },

    /**
     * 金額設定よるソート
     * @param target 対象データ
     */
    setSort(target) {
      const sortArr = [undefined, '1', '2', '3']
      let result = []
      for (let l = 0; l < sortArr.length; l++) {
        const sort = sortArr[l]
        for (let m = 0; m < target.length; m++) {
          const er = target[m]
          if (er.priceCode.split('-')[1] == sort) {
            result.push(er)
          }
        }
      }
      return result
    },

    /**
     * エリア名生成
     */
    getEria(target) {
      let result = []
      for (let i = 0; i < target.length; i++) {
        const e = target[i]
        result.push(e.city + ' ' + e.street)
      }
      return result.join('\r\n')
    },

    /**
     * 変更イベント
     */
    changeData(target) {
      // ログに出力する項目名を生成
      let code = null
      if (target.priceCode != '') {
        code = target.priceCode.split('-')
      }
      let name1 = ''
      let name2 = ''

      if (!code) {
        name1 = '単価'
      } else {
        name1 = '駐車場代：'
      }

      if (code && code[1] ==  '1') {
        name2 = '超都心'
      } else if (code && code[1] ==  '2') {
        name2 = '都心'
      } else if (code && code[1] ==  '3') {
        name2 = 'その他'
      }
      
      target.itemName = name1 + name2
      this.$emit('changePrice', target)
    }
  }
}
</script>
<style scoped>
/* .main {
  min-width: 2700px;
} */

.hover-color:hover {
  background: rgba(163, 231, 228, 0.67) !important;
  color: rgb(16, 16, 208);
}

.border-orange {
  border: 1px solid rgb(241, 171, 135);
}

.border-orange-b {
  border-bottom: 1px solid rgb(241, 171, 135);
}

.orange {
  background: rgba(247, 201, 173, 0.67);
}

.hover-color2:hover {
  background: rgba(247, 201, 173, 0.67) !important;
}

.left-100p {
  left: 100px;
}

.text-orange {
  color: rgb(163, 108, 4);
}

.th-name {
  min-width: 150px;
}

</style>
